module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt20 ovh min_height",
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetail == 0),
      expression: "showDetail == 0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.agreementList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "contractCode",
      "label": "合同编号",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "parentContractCode",
      "label": "原合同编号",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contractName",
      "label": "合同名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合作状态",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.status == 1 ? '正常合作' : '终止合作') + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "开始时间",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("time")(scope.row.contractStartDate)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "结束时间",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("time")(scope.row.contractEndDate)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.detail(scope.row.id)
            }
          }
        }, [_vm._v("详情")]), _vm._v(" "), (scope.row.renewStatus == 2 && _vm.isSupplier == 1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.renew(scope.row.id)
            }
          }
        }, [_vm._v("续签")]) : _vm._e(), _vm._v(" "), (_vm.hasEditContract == 1 && scope.row.status == 1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.stop(scope.row.id)
            }
          }
        }, [_vm._v("终止")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetail == 1),
      expression: "showDetail == 1"
    }],
    staticClass: "pl10 mt20"
  }, [_c('span', {
    staticClass: "dib"
  }, [_vm._v("合同基本信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "供应商合同编号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.contractCode))])]), _vm._v(" "), (_vm.agreementDetail.parentContractId > 0) ? _c('el-form-item', {
    attrs: {
      "label": "供应商原合同编号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.parentContractCode))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商编号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.suppliersCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商名称："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.suppliersName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合作方式："
    }
  }, [(_vm.agreementDetail.cooperationType == 1) ? _c('span', [_vm._v("入仓")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.cooperationType == 2) ? _c('span', [_vm._v("入仓（实销实结）")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.cooperationType == 3) ? _c('span', [_vm._v("自发货")]) : _vm._e()]), _vm._v(" "), (_vm.agreementDetail.cooperationType == 3) ? _c('el-form-item', {
    attrs: {
      "label": "发货时效："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.deliveryTime) + "小时")])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同开始时间："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.contractStartTime))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同结束时间："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.contractEndTime))])]), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("合同条款-财务信息")]), _c('span', {
    staticClass: "second_line"
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算主体："
    }
  }, [(_vm.agreementDetail.settlementBodyId == 1) ? _c('span', [_vm._v("北京果敢时代科技有限公司")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementBodyId == 2) ? _c('span', [_vm._v("MAMA HONG KONG")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementBodyId == 3) ? _c('span', [_vm._v("天津果敢时代国际贸易有限公司")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementBodyId == 4) ? _c('span', [_vm._v("正合奇胜（天津）企业咨询管理有限公司")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementBodyId == 5) ? _c('span', [_vm._v("老师线下打款")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式："
    }
  }, [(_vm.agreementDetail.settlementType == 1) ? _c('span', [_vm._v("直采")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementType == 2) ? _c('span', [_vm._v("预付款")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementType == 3) ? _c('span', [_vm._v("实销实结")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算币种："
    }
  }, [_vm._v("人民币")]), _vm._v(" "), (_vm.agreementDetail.settlementType != 2 && _vm.agreementDetail.settlementPaymentType == 0) ? _c('el-form-item', {
    attrs: {
      "label": "结算账期："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.settlementPaymentDays) + "天")])]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementType != 2 && _vm.agreementDetail.settlementPaymentType && _vm.agreementDetail.settlementPaymentType >= 2) ? _c('el-form-item', {
    attrs: {
      "label": "结算账期："
    }
  }, [(_vm.agreementDetail.settlementPaymentType == 2) ? _c('span', [_vm._v("按年结算")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementPaymentType == 3) ? _c('span', [_vm._v("按半年结算")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementPaymentType == 4) ? _c('span', [_vm._v("按季度结算")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementPaymentType == 5) ? _c('span', [_vm._v("按月结算")]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementPaymentType == 6) ? _c('span', [_vm._v("按半月结算")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.settlementType == 2 && _vm.agreementDetail.settlementPaymentRate && _vm.agreementDetail.settlementPaymentRate != '0') ? _c('el-form-item', {
    attrs: {
      "label": "结算账期："
    }
  }, _vm._l((_vm.agreementDetail.settlementPaymentRate.split(',')), function(paymentRate, index) {
    return _c('span', [_vm._v(_vm._s(index == 0 ? "" : ",") + "第" + _vm._s(index + 1) + "期" + _vm._s(paymentRate) + "%")])
  })) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "保证金："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.deposit) + "人民币")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "货款支付方式："
    }
  }, [_vm._v("甲方将货款直接支付到乙方的如下银行账户")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.bankName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行账号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.accountNumber))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行户名："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.accountName))])]), _vm._v(" "), (_vm.agreementDetail.registeredCountry != 1) ? _c('el-form-item', {
    attrs: {
      "label": "SwiftCode："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.swiftCode))])]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.registeredCountry == 1) ? _c('el-form-item', {
    attrs: {
      "label": "省："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.province))])]) : _vm._e(), _vm._v(" "), (_vm.agreementDetail.registeredCountry == 1) ? _c('el-form-item', {
    attrs: {
      "label": "市："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreementDetail.city))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("线上合同信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同名称："
    }
  }, _vm._l((_vm.agreementDetail.templateContents), function(content, index) {
    return _c('span', [_c('el-button', {
      attrs: {
        "type": "text",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.contentDetail(content)
        }
      }
    }, [_vm._v(" " + _vm._s(content.name) + " ")])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "w60 auto mt120"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.reback()
      }
    }
  }, [_vm._v("返回合同协议列表")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ba32b5f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplierInfo/agreementList.vue
// module id = 484
// module chunks = 0